module.exports = __webpack_public_path__ + "media/video04.163c8ce2.mp4";